import { formatIQD, formatDateTime } from '../../../shared/format.js';
import { ReceiptBrand } from '../../../shared/ReceiptBrand.jsx';
import { useReceptionForm } from '../hooks/useReceptionForm.js';
import { useSubscriptionCoverage } from '../hooks/useSubscriptionCoverage.js';

export function ReceiptPreview() {
  const guardian = useReceptionForm((s) => s.guardian);
  const children = useReceptionForm((s) => s.children);
  const pricing = useReceptionForm((s) => s.pricing);
  const payment = useReceptionForm((s) => s.payment);
  const coverage = useSubscriptionCoverage();
  const payingChildren = children.filter((c) => !coverage.isCovered(c));

  const pkgLabel =
    pricing.type === 'package' && pricing.package ? pricing.package.name :
    pricing.type === 'hourly' ? 'تسعير ساعي' :
    pricing.type === 'open' ? 'وقت مفتوح' :
    pricing.type === 'fixed' ? 'مبلغ ثابت' :
    '—';

  const amount =
    pricing.type === 'package' && pricing.package ? pricing.package.price :
    pricing.type === 'open' ? Number(pricing.openAmount) || 0 :
    pricing.type === 'fixed' ? Number(pricing.fixedAmount) || 0 :
    Number(pricing.estimatedAmount) || 0;

  // المشترك شهرياً لا يدخل في إجمالي الإيصال — الخادم لا يُفوتره.
  const total = amount * payingChildren.length;
  const now = new Date();

  return (
    <div
      className="mx-auto bg-white text-ink p-4"
      style={{
        width: 280,
        fontFamily: '"Tajawal", monospace',
        fontSize: 12,
        boxShadow: '0 4px 14px rgba(0,0,0,.08)',
        borderRadius: 8
      }}
    >
      <ReceiptBrand subtitle="إيصال دخول" />
      <hr className="border-dashed my-1" />
      <div className="flex justify-between"><span>التاريخ</span><span dir="ltr">{formatDateTime(now)}</span></div>
      <div className="flex justify-between"><span>ولي الأمر</span><span>{guardian.name || '—'}</span></div>
      <div className="flex justify-between"><span>الهاتف</span><span dir="ltr">{guardian.phone || '—'}</span></div>
      <hr className="border-dashed my-1" />
      <div className="font-semibold mb-1">الأطفال:</div>
      {children.map((c, i) => (
        <div key={c.tempId} className="flex justify-between">
          <span>
            {i + 1}. {c.name || '—'}
            {coverage.isCovered(c) ? ' (اشتراك شهري)' : ''}
          </span>
          <span dir="ltr" style={{ fontFamily: 'monospace' }}>{c.cardUid || '—'}</span>
        </div>
      ))}
      <hr className="border-dashed my-1" />
      <div className="flex justify-between"><span>الباقة</span><span>{pkgLabel}</span></div>
      <div className="flex justify-between"><span>الكميّة المحاسَبة</span><span>{payingChildren.length}</span></div>
      {payingChildren.length !== children.length ? (
        <div className="flex justify-between"><span>مشتركون شهرياً</span><span>{children.length - payingChildren.length}</span></div>
      ) : null}
      <div className="flex justify-between"><span>طريقة الدفع</span><span>{payment.method === 'cash' ? 'نقدي' : payment.method === 'card' ? 'بطاقة' : 'تحويل'}</span></div>
      <hr className="border-dashed my-1" />
      <div className="flex justify-between font-extrabold text-[14px]">
        <span>الإجمالي</span>
        <span style={{ color: '#C2570D' }}>{formatIQD(total)}</span>
      </div>
      <div className="text-center text-[10px] mt-2">شكراً لزيارتكم</div>
    </div>
  );
}
